import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAllFolders, getConnectedContact, getContactGroup, getConversationsAPIHelper, getGroupMembersAPIHelper, getSelectedFolderDetails, getUserFolderDetails, getusersSearchResultsAPIHelper, postContactNonuser, postCreateContactGroup, postEditContactGroup, sendGroupCallInvitaionHelper } from "../helpers/ContactHelperApis";
// import { initialState } from "react-doc-viewer/build/state/reducer";

const initialState = {
    ConnectedContact: [],
    UserFolderDetails: [],
    ContactGroup: [],
    ContactCreateGroup: {},
    ContactEditGroup: {},
    ContactNonuser: {},
    allFolders: [],
    groupMembersData:[],
    selectedFolder: null,
    AgoraToken: null,
    selectedFolderId: null,
    loading: false,
    allConversations:{},
    globalusersData:[],
    activeConversation: {
        type: null,           // "group" | "direct" | null
        id: null,             // group id or user id
        name: null,           // group name or user display name
        conversationId: null, // optional chat service conversation id
        payload: null,
        group_image:null       // optional full payload (members, profile, etc.)
    },
};

export const getConnectedReducer = createAsyncThunk('/getConnectedcontact', async (_, thunkAPI) => {

    try {
        const response = await getConnectedContact();
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
});




export const getUserFolderDetailsReducer = createAsyncThunk('/getUserFolderDetails', async (_, thunkAPI) => {
    try {
        const response = await getUserFolderDetails();
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);
    }
});

export const getContactGroupReducer = createAsyncThunk('/getContactGroup', async (_, thunkAPI) => {
    try {
        const response = await getContactGroup();
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);
    }
});

export const postCreateContactGroupReducer = createAsyncThunk('/postcreatecontactgroup', async (formData, thunkAPI) => {
    try {
        const response = await postCreateContactGroup(formData);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
});


export const postEditContactGroupReducer = createAsyncThunk('/postEditcontactgroup', async (formData, thunkAPI) => {
    try {
        const response = await postEditContactGroup(formData);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
})


export const postContactNonuserReducer = createAsyncThunk('/postContactNonuser', async (formData, thunkAPI) => {
    try {
        const response = await postContactNonuser(formData);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
})

export const getAllFoldersReducer = createAsyncThunk('contacts/getAllFolders', async (_, thunkAPI) => {
    try {
        const response = await getAllFolders();
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
}
);

export const getSelectedFolderReducer = createAsyncThunk('contacts/getSelectedFolder', async (params, thunkAPI) => {
    try {
        const response = await getSelectedFolderDetails(params);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
}
);

export const getAgoraTokenReducer = createAsyncThunk('contacts/getAgoraToken', async (params, thunkAPI) => {
    try {
        const response = await getSelectedFolderDetails(params);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
}
);


export const sendGroupCallInvitaion = createAsyncThunk('contacts/sendGroupInvitaion', async (params, thunkAPI) => {
    try {
        const response = await sendGroupCallInvitaionHelper(params);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
}
);



export const getAllConversations = createAsyncThunk('contacts/getAllConversations', async (thunkAPI) => {
    try {
        const response = await getConversationsAPIHelper()
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
}
);

export const getGroupMembers = createAsyncThunk('contacts/getGroupMembersAPIHelper', async (params,thunkAPI) => {
    try {
        const response = await getGroupMembersAPIHelper(params)
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
}
);

export const getGlobleUsers = createAsyncThunk('contacts/getGlobleUsers', async (params,thunkAPI) => {
    try {
        const response = await getusersSearchResultsAPIHelper(params)
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
}
);

const ContactSlice = createSlice({
    name: 'Contact',
    initialState,
    reducers: {
        clearContactState: (state) => {
            state.ConnectedContact = [];
        },
        setActiveConversation(state, action) {
            state.activeConversation = {
                ...state.activeConversation,
                ...action.payload,
            };
        },
        clearActiveConversation(state) {
            state.activeConversation = { ...initialState.activeConversation };
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getConnectedReducer.fulfilled, (state, action) => {
                state.ConnectedContact = action.payload.data;
            })
            .addCase(getConnectedReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })
            .addCase(getUserFolderDetailsReducer.fulfilled, (state, action) => {
                state.UserFolderDetails = action.payload;

            }).addCase(getUserFolderDetailsReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })
            .addCase(getContactGroupReducer.fulfilled, (state, action) => {
                state.ContactGroup = action.payload.data;
            })
            .addCase(getContactGroupReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })
            .addCase(postCreateContactGroupReducer.fulfilled, (state, action) => {
                state.ContactCreateGroup = action.payload.data;
            })
            .addCase(postCreateContactGroupReducer.rejected, (state, action) => {
                state.error = action.payload.error;
            })
            .addCase(postEditContactGroupReducer.fulfilled, (state, action) => {
                state.ContactEditGroup = action.payload.data;
            })
            .addCase(postEditContactGroupReducer.rejected, (state, action) => {
                state.error = action.payload.error;
            })
            .addCase(postContactNonuserReducer.fulfilled, (state, action) => {
                state.ContactNonuser = action.payload.data;
            })
            .addCase(postContactNonuserReducer.rejected, (state, action) => {
                state.error = action.payload.error;
            })
            .addCase(getAllFoldersReducer.fulfilled, (state, action) => {
                state.allFolders = action.payload.data;
                state.loading = false;
            })
            .addCase(getAllFoldersReducer.rejected, (state, action) => {
                state.error = action.payload?.message || 'Error loading folders';
                state.loading = false;
            })
            .addCase(getSelectedFolderReducer.fulfilled, (state, action) => {
                state.selectedFolder = action.payload.data;
                state.loading = false;
            })
            .addCase(getSelectedFolderReducer.rejected, (state, action) => {
                state.error = action.payload?.message || 'Error loading single folder';
                state.loading = false;
            })
            .addCase(getAgoraTokenReducer.fulfilled, (state, action) => {
                state.AgoraToken = action.payload;
                state.loading = false;
            })
            .addCase(sendGroupCallInvitaion.fulfilled, (state, action) => {
                state.error = action.payload.error;
                state.loading = false;
            })
            .addCase(getAgoraTokenReducer.rejected, (state, action) => {
                state.error = action.payload?.message || 'Error loading single folder';
                state.loading = false;
            })
            .addCase(getAllConversations.fulfilled, (state, action) => {
                state.allConversations = action.payload;
                state.loading = false;
            })
            .addCase(getAllConversations.rejected, (state, action) => {
                state.error = action.payload?.message || 'Error loading single folder';
                state.loading = false;
            })
            .addCase(getGroupMembers.fulfilled, (state, action) => {
                state.groupMembersData = action.payload;
                state.loading = false;
            })
            .addCase(getGroupMembers.rejected, (state, action) => {
                state.error = action.payload?.message || 'Error loading single folder';
                state.loading = false;
            })
            .addCase(getGlobleUsers.fulfilled, (state, action) => {
                state.globalusersData = action.payload;
                state.loading = false;
            })
            .addCase(getGlobleUsers.rejected, (state, action) => {
                state.error = action.payload?.message || 'Error loading single folder';
                state.loading = false;
            })
    }
});
// export const {setActiveConversation, clearContactState } = ContactSlice.actions;
// export const selectActiveConversation = (state) => state?.chat?.activeConversation;
// export default ContactSlice.reducer;


export const { clearContactState, setActiveConversation, clearActiveConversation } = ContactSlice.actions;
export const selectActiveConversation = (state) => state?.Contact?.activeConversation;
export default ContactSlice.reducer;